/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import UpdateProfile from './UpdateProfile';
import UpdateButton from '../../UpdateButton';
import { UpdateDocumentValidation } from '../../UpdateDocument/UpdateDocumentValidation';
import { dataService } from '../../../services/data.services';
import { Auth } from 'aws-amplify';
import ViewSkeleton from './Shimmers/ViewSkeleton';
import ViewProfile from './ViewProfile';
import GlobalContext from '../../Context/GloablContext';
import { UpdateApiValidation } from './UpdateProfile/UpdateApiValidation';
import BranchModal from '../BranchModal';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CardHeader from '../../CardHeader';
import InputField from '../../InputFeld';
import { HandleInputChange } from '../../InputFeld/inputChange';
import { FormattedNumber } from '../../../CommonMethods/FormattedNumber';
import LoadingOverlay from 'react-loading-overlay-ts';
import Toast from '../../Toast';

const ProfileInstitution = () => {
    const {GlobalChange}=useSelector((state)=>state.GlobalData);
    const panCardRegex=/[A-Z]{5}[0-9]{4}[A-Z]{1}/
    const {setToastmessage}=useContext(GlobalContext)
    const [Type, setType] = useState('')
    const location = useNavigate()
    const [updateLoading, setUpdateLoading] = useState(true);
    const [swithBranch, setswithBranch] = useState(false)
    const [submitSelected, setsubmitSelected] = useState(false);
    const [toastErrorMessage,setToastErrorMessage]=useState('');
    const [customError, setcustomError] = useState([])
    const initialDocument = {
        registration_12a_certificate_number: "",
        registration_12a_file_url: "",
        registration_80g_certificate_number: "",
        registration_80g_file_url: "",
        registration_10_23c_certificate_number: "",
        registration_10_23c_file_url: "",
        approval_number: "",
        approval_registration_file_url: "",
        pf_registration_certificate_number: "",
        pf_registration_file_url: "",
        esi_registration_certificate_number: "",
        esi_registration_file_url: "",
        pt_registration_certificate_number: "",
        pt_registration_file_url: "",
        registration_number: "",
        tan_number: "",
        tan_file_url: "",
        pan_file_url: "",
        pan_number: "",
        gst_file_url: "",
        gst_number: ""
    }
    
    const [updateDocumentSate, setUpdateDocumentSate] = useState(initialDocument)
    const [isUpdateDocument, setIsUpdateDocument] = useState(false)
    const [updateDocumentError, setUpdateDocumentError] = useState({
        pan_file_url: false,
        pan_number: false,
        registration_number: false,
        pan_validate : false,
    })
    const [formatError, setformatError] = useState('')

    const handlePanCheck=()=>{
        return panCardRegex.test(updateDocumentSate.pan_number)
    }
    const handleOnCLickUpdate = async(e) => {
        
        if(isUpdateDocument){
            setUpdateLoading(true);
            setcustomError([])
            setsubmitSelected(true);
            setToastErrorMessage('')
            if(updateDocumentSate.gst_number.length !== 15 && updateDocumentSate.gst_number !== ''){
                const arr=[];
                arr.push('gst_number');
                setcustomError(arr);
                setUpdateLoading(false);
                setToastErrorMessage('Length of GSTIN should be 15')
                return
            }
           
            if(UpdateDocumentValidation(updateDocumentError,setUpdateDocumentError, updateDocumentSate) ||!handlePanCheck() ) {
                if(updateDocumentSate.pan_number!=='' && !handlePanCheck()){
                    const arr=[];
                    arr.push('pan_number');
                    setcustomError(arr);
                    setToastErrorMessage('Please enter valid details');
                    setUpdateLoading(false);
                    return

                    
                }
                setUpdateLoading(false);
                setToastErrorMessage('Please fill in all the mandatory fields')

            } else {
                try {
                    let body = await UpdateApiValidation(initialDocument, updateDocumentSate)
                    let endpoint= `${Type.toLowerCase()}/${updateDocumentSate._id}`
                    const response = await dataService.PatchAPI(body,endpoint);
                    setIsUpdateDocument(false);
                    setUpdateLoading(false);
                    setToastmessage(`${Type} information updated successfully`);
                    setToastErrorMessage('')
                    getInstitutionUserData();
                } catch (error) {
                    setUpdateLoading(false)
                    setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                } 
            }
        } else {
            setIsUpdateDocument(true);
        }
    }
    const handleType=(key)=>{
        let val=''
        if(key==='institution-user' || key==='institution-admin'){
            val='Institution'
        }else if(key==='branch-user'){
            val='Branch'

        }
        
        return val
    }
    const getInstitutionUserData = async() => {
        
        let institution_id = "";
        try{
            const user1 = await Auth.currentSession()
            setType(handleType(user1.idToken.payload["custom:user_type"]))
            institution_id = handleType(user1.idToken.payload["custom:user_type"]) === "Institution" ? user1.idToken.payload["custom:institution_id"] :  user1.idToken.payload["custom:branch_id"] 
            let res = await dataService.GetAPI(`${handleType(user1.idToken.payload["custom:user_type"]).toLowerCase()}/${institution_id}`);
            handleType(user1.idToken.payload["custom:user_type"]) === "Institution" && localStorage.setItem("institutionData", JSON.stringify({"name" : res.data.data.data.institution_name, "id" : res.data.data.data.institution_id}));
            const resVal = handleType(user1.idToken.payload["custom:user_type"]) === "Institution" ? res.data.data.data :  res.data.data 
            setUpdateDocumentSate((prevState) => ({ ...prevState, ...resVal }));
            setUpdateLoading(false);
        }catch(error){
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error) 
        }
        
        
    }

    useEffect(() => {
        getInstitutionUserData()
        return(()=>{
            setType('')
        })
    }, [GlobalChange])

    const handleOnchangeInput = (e) => {
        if(e.target.id === "registration_number") {
            setUpdateDocumentError((prevState) => ({ ...prevState, "registration_number": false }));
        }
        HandleInputChange(e, setUpdateDocumentSate)
    }

    const handleCancel = (e) => {
        setIsUpdateDocument(false)
        setToastErrorMessage("")
        setsubmitSelected(false)
        setUpdateDocumentError({
            pan_file_url: false,
            pan_number: false,
            registration_number: false,
            pan_validate : false,
        })
        getInstitutionUserData()
    }

    return (       

        <CardHeader noPadding  >
            {updateLoading ? <ViewSkeleton Type={Type}/> : (
                <LoadingOverlay
                    active={false}
                    spinner
                    text={`Loading ${Type === "Branch" ? "Branch" : "Institution"} Profile...`}
                > 
                    { (toastErrorMessage!=='' || updateDocumentSate?.registration_number === "") && <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage} />}
                    <div class="mainDataCntnrTop shadow-s13" style={{position: "sticky", position: "-webkit-sticky"}}>
                        <h5 class="pageHeader adderror">{Type} Profile</h5>
                        <div class="flex items-center">
                            {isUpdateDocument && 
                            <button
                                type="button"
                                onClick={() => handleCancel()}
                                class="cancl-btn"
                            >
                                Cancel 
                            </button>}
                            <UpdateButton 
                                ButtonName={!isUpdateDocument ? "Edit" : "Update"}
                                loading={updateLoading}
                                classKey={"actn-btn onboardInstitution"}
                                id={"update-institution-profile"}
                                handleOnCLick={handleOnCLickUpdate}
                            />
                        </div>
                    </div>
                    <div className='mainDataCntnrPageDiv scrollBlue_thick'>
                        <div class="flex">
                            <div class="w-[100%] mx-auto">
                                <div 
                                    class="border border-[#D0D5DD] p-4 w-[90%] mx-auto"
                                    animate={{ x: 0 }}
                                    initial={{ x: -10 }}
                                    transition={{duration:0.5}}
                                >
                                    <div class="flex -mx-2">
                                        <div class="w-[60%] px-2">
                                            <div class="w-full">
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px] adderror">{Type} Name</p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words">{Type === "Branch" ? updateDocumentSate.branch_name : updateDocumentSate.institution_name}</p>
                                                        {!updateLoading &&<div class={`w-fit rounded ${updateDocumentSate.status ? 'bg-[#C5FFD5]' : 'bg-[#B3BBC1]'} flex items-center justify-center py-1 px-2.5 ml-6`}>
                                                            <img loading="lazy" decoding="async"src={updateDocumentSate.status ? "/images/successDot.svg" : "/images/inactive-Dot.svg" } alt="icon"/>
                                                            <span class="text-f7 font-normal text-[#031624] pl-1">{updateDocumentSate.status ? 'Active' : 'Inactive'}</span>
                                                        </div>}
                                                    </div>
                                                </div>
                                                <div class="flex items-center mt-6">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px] self-start">Address </p>
                                                    <div class="flex items-center w-full">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words self-start">{updateDocumentSate.address_line_1}, {updateDocumentSate.address_line_2}<br/>
                                                            {updateDocumentSate.area}, {updateDocumentSate.city} <br/>
                                                            {updateDocumentSate.state} - {updateDocumentSate.pincode}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="flex items-center mt-4">
                                                    <label for="Registration" class="text-f7 font-normal text-[#031624] min-w-[130px] h-[40px]">Registration No.</label>
                                                    {isUpdateDocument ? <InputField
                                                        inputId={"registration_number"}
                                                        inputLabel={"Registration Number"}
                                                        inputType={"text"}
                                                        inputPlaceholder={"Enter Registration Number"}
                                                        inputDisabled={false}
                                                        inputErrorMessage={updateDocumentError.registration_number ? "Registration number is mandatory" : ""}
                                                        inputMaxLength={20}
                                                        isMandatoryField = {true}
                                                        inputWidth = {'w-[220px]'}
                                                        inputValue={updateDocumentSate.registration_number}
                                                        inputChange={handleOnchangeInput}
                                                    /> : <p class="text-f7 font-semibold text-[#031624]  h-[40px]">{updateDocumentSate.registration_number}</p>}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-[40%] px-2">
                                            <div class="w-full">
                                                <h5 class="text-f7 font-semibold text-[#000000] break-words pb-2">Point of Contact</h5>
                                                <div class="flex items-start">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]">Name</p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words">{updateDocumentSate.poc_name}</p>
                                                    </div>
                                                </div>
                                                <div class="flex items-start mt-4">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]">Email Address</p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words truncate">{updateDocumentSate.poc_email_address}</p>
                                                    </div>
                                                </div>
                                                <div class="flex items-center mt-4">
                                                    <p class="text-f7 font-normal text-[#031624] min-w-[130px]">Mobile Number</p>
                                                    <div class="flex items-center">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words">{updateDocumentSate.poc_mobile_number ? FormattedNumber(updateDocumentSate?.poc_mobile_number.toString()) : '-'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>     
                                {!isUpdateDocument ?
                                    <div
                                        animate={{ x: 0 }}
                                        initial={{ x: -10 }}
                                        transition={{duration:0.5}}
                                    >
                                        <ViewProfile updateDocumentSate={updateDocumentSate} Type={Type}/>
                                    </div> :
                                    <UpdateProfile 
                                        setUpdateDocumentSate={setUpdateDocumentSate}
                                        updateDocumentSate={updateDocumentSate}
                                        updateDocumentError={updateDocumentError}
                                        setUpdateDocumentError={setUpdateDocumentError}
                                        formatError={formatError}
                                        setformatError={setformatError}
                                        Type={Type}
                                        customError={customError}
                                        setcustomError={setcustomError}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    {swithBranch &&<BranchModal 
                        title={"Select Branch"} show={swithBranch} handleClose={()=>setswithBranch(false)} />  }
                </LoadingOverlay>
            )}
            
        </CardHeader>        
    );
}

export default ProfileInstitution;
